<template>
  <div v-show="styles_loaded" :class="setbrandid" :style="new_style_variables">
    <Header
      :logo_link="logo_link"
      :home_link="home_link"
      :header_menu="header_menu"
      :show_basket="show_basket"
      :show_home="true"
      :show_languages="true"
      :basket_number="0"
      :logo_image="logo_image"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="brandSlug"
      :highlight_tab_item="'FAQs'"
    ></Header>

    <div class="page-bg faq-page">
      <div class="confirmation-banner-container">
        <ConfirmationBanner
          :headline="getrans('FAQ - Frequently asked questions and answers')"
          :subheadline="''"
          edit-label="Edit"
        >
        </ConfirmationBanner>
      </div>

      <div class="page-container">
        <div class="page-left">
          <template v-if="brandSlug !== 'HER'">
            <template
              v-for="faq_data in faqs_api_data"
              :key="faq_data.langauge_id"
            >
              <template
                v-if="
                  lang.toUpperCase() === faq_data.langauge_code.toUpperCase()
                "
              >
                <template
                  v-for="category in faq_data.category"
                  :key="category.category_id"
                >
                  <div class="faq-top-section">
                    <h3>{{ getrans(category.category_name) }}</h3>
                    <p v-html="category.description"></p>
                  </div>

                  <!-- accordions -->
                  <template
                    v-for="question_answer in category.question_answer"
                    :key="question_answer.question"
                  >
                    <div class="faq-wrapper">
                      <div class="faq-toggler" @click="toggleFaq($event)">
                        <h2>{{ question_answer.question }}</h2>
                        <i class="fas fa-chevron-right"></i>
                      </div>
                      <div class="faq-content-wrap">
                        <p v-html="question_answer.answer"></p>
                      </div>
                    </div>
                  </template>
                  <!-- accordions -->
                </template>
              </template>
            </template>
          </template>

          <template v-if="brandSlug === 'HER'">
            <div class="faq-top-section">
              <h2></h2>
              <p>LCA COVERED PARKING AREA:</p>
            </div>

            <!-- accordions -->

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>Q. Do the prices shown include VAT?</h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>Yes, the prices as presented are final.</p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. I'm trying to book for today but the system doesn’t allow
                  me to proceed.
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  This is because the reservation system allows you to book at
                  least 2 hours before the desired arrival time at the airport.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. I paid the booking but I have NOT received the booking
                  confirmation.
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  This may happen for two reasons.<br />
                  (a) The email address provided on your personal data is
                  incorrect and therefore the booking confirmation was sent
                  elsewhere.
                  <br /><br />
                  (b) The booking was not completed due to a technical problem,
                  even though the payment was processed succesfully.
                  <br /><br />
                  Contact us at booking@hermesairports.com to resolve the
                  issue.<br /><br />
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. What time do I need to set for arrival at the airport if
                  the flight departs at 08:00 am?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  It is advised to set the booking arrival time at least 2 hours
                  before your flight departs.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. I ‘ve chosen the wrong airport for my booking and the
                  system doesn’t allow me to change it.
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  In this case, change of the airport is not possible. You will
                  need to cancel the booking through the cancellation process
                  and make another booking with the correct information. The
                  system will automatically refund the amount of your cancelled
                  reservation and will be transferred to your account within 3-5
                  business days.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Are there any special conditions attached to my booking?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  No, you are booking a flexible product which means if you need
                  to change your dates, because your travel plans change – you
                  can! There is no administration fee for making changes unless
                  you wish to alter your dates to a longer period of stay in
                  which case you will need to pay the difference. For example,
                  if you booked 8 days and wish to extend to 10 days; you will
                  be charged again for the additional amount. <br /><br />
                  Another example would be a change in the month – supposing you
                  booked for a week in March and wish to change it to July, then
                  an additional charge may be imposed due to the different rates
                  apply for July which is considered peak season.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Do you apply charges for booking or cancelling a
                  reservation?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>No additional charges apply.</p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. What is the time limit for booking cancellations or
                  amendments?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  Cancellation of the booking is possible at least 24 hours
                  prior the commencement of your booking and allows you for full
                  refund of the amount.
                  <b
                    >Failure to do so, will not receive any refund and you will
                    not be entitled to any compensation whatsoever</b
                  >. In regards to change booking details, this can be applied
                  at least 6 hours prior the commencement of your reservation.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Can I come in a different car than the one I have declared
                  on the online booking?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  No, you must use the car you have declared, since the number
                  plate is automatically recognised for the barrier to open.
                  Should you come in a different car, the barrier will not open.
                  You also have the option to modify your booking details at
                  least 24 hours prior to your arrival at the airport.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Will the barrier open if I come to park earlier than what I
                  have stated on my booking?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  The booking reservation is activated maximum 60 minutes
                  earlier than the time stated on your booking arrival time.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>Q. I lost my parking ticket. What to do?</h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  The ticket is necessary so if you lost it, please request from
                  the parking operator to re-issue your ticket. <br /><br />

                  (a) The ticket is required to exit the gate. Scan the ticket
                  at the dedicated spot to activate the barrier. <br /><br />

                  (b) If you have exceeded the pre-paid period, the ticket is
                  required to pay the overstay fee. <br /><br />
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Although I have a confirmed booking, when I came to the
                  airport, the barrier didn’t open. What to do?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  This means that your reservation is not triggered either
                  because your number plates are different from the ones you
                  have stated on your reservation or because the vehicle number
                  plates have not been decoded correctly by the system. Press
                  the ticket button for a regular ticket and go to the Parking
                  Office to activate your reservation.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Are there any facilities for people with special needs?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  There are special parking spaces for people with reduced
                  mobility and are located within the Short Stay Parking. These
                  spaces CANNOT be booked online. If you plan to travel and wish
                  to use such a place, we offer special discounts for Long Term
                  Parking to Blue Card holders. Just visit the "Parking Office"
                  to get the discount.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>Q. How safe is my car in the parking area?</h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  All parking areas at the airport are provided to park at your
                  own risk. All sites are regularly patrolled for airport
                  security purposes.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. My flight is delayed. I will return an hour later than
                  scheduled. Do I have to pay extra for parking?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  No, you will not have to pay extra if the maximum delay is up
                  to 4 hours. The booking system automatically provides you with
                  an additional time of up to 4 hours.
                </p>
              </div>
            </div>

            <div class="faq-top-section">
              <h2></h2>
              <p>LCA UNCOVERED PARKING AREA:</p>
            </div>

            <!-- accordions -->

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>Q. Do the prices shown include VAT?</h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>Yes, the prices as presented are final.</p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. I'm trying to book for today but the system doesn’t allow
                  me to proceed.
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  This is because the reservation system allows you to book at
                  least 2 hours before the desired arrival time at the airport.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. I paid the booking but I have NOT received the booking
                  confirmation.
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  This may happen for two reasons.<br />
                  (a) The email address provided on your personal data is
                  incorrect and therefore the booking confirmation was sent
                  elsewhere.
                  <br /><br />
                  (b) The booking was not completed due to a technical problem,
                  even though the payment was processed succesfully.
                  <br /><br />
                  Contact us at booking@hermesairports.com to resolve the
                  issue.<br /><br />
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. What time do I need to set for arrival at the airport if
                  the flight departs at 08:00 am?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  It is advised to set the booking arrival time at least 2 hours
                  before your flight departs.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. I ‘ve chosen the wrong airport for my booking and the
                  system doesn’t allow me to change it.
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  In this case, change of the airport is not possible. You will
                  need to cancel the booking through the cancellation process
                  and make another booking with the correct information. The
                  system will automatically refund the amount of your cancelled
                  reservation and will be transferred to your account within 3-5
                  business days.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Are there any special conditions attached to my booking?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  No, you are booking a flexible product which means if you need
                  to change your dates, because your travel plans change – you
                  can! There is no administration fee for making changes unless
                  you wish to alter your dates to a longer period of stay in
                  which case you will need to pay the difference. For example,
                  if you booked 8 days and wish to extend to 10 days; you will
                  be charged again for the additional amount. <br /><br />
                  Another example would be a change in the month – supposing you
                  booked for a week in March and wish to change it to July, then
                  an additional charge may be imposed due to the different rates
                  apply for July which is considered peak season.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Do you apply charges for booking or cancelling a
                  reservation?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>No additional charges apply.</p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. What is the time limit for booking cancellations or
                  amendments?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  Cancellation of the booking is possible at least 24 hours
                  prior the commencement of your booking and allows you for full
                  refund of the amount.
                  <b
                    >Failure to do so, will not receive any refund and you will
                    not be entitled to any compensation whatsoever</b
                  >. In regards to change booking details, this can be applied
                  at least 6 hours prior the commencement of your reservation.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Can I come in a different car than the one I have declared
                  on the online booking?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  No, you must use the car you have declared, since the number
                  plate is automatically recognised for the barrier to open.
                  Should you come in a different car, the barrier will not open.
                  You also have the option to modify your booking details at
                  least 24 hours prior to your arrival at the airport.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Will the barrier open if I come to park earlier than what I
                  have stated on my booking?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  The booking reservation is activated maximum 60 minutes
                  earlier than the time stated on your booking arrival time.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>Q. I lost my parking ticket. What to do?</h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  The ticket is necessary so if you lost it, please request from
                  the parking operator to re-issue your ticket. <br /><br />

                  (a) The ticket is required to exit the gate. Scan the ticket
                  at the dedicated spot to activate the barrier. <br /><br />

                  (b) If you have exceeded the pre-paid period, the ticket is
                  required to pay the overstay fee. <br /><br />
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Although I have a confirmed booking, when I came to the
                  airport, the barrier didn’t open. What to do?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  This means that your reservation is not triggered either
                  because your number plates are different from the ones you
                  have stated on your reservation or because the vehicle number
                  plates have not been decoded correctly by the system. Press
                  the ticket button for a regular ticket and go to the Parking
                  Office to activate your reservation.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. Are there any facilities for people with special needs?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  There are special parking spaces for people with reduced
                  mobility and are located within the Short Stay Parking. These
                  spaces CANNOT be booked online. If you plan to travel and wish
                  to use such a place, we offer special discounts for Long Term
                  Parking to Blue Card holders. Just visit the "Parking Office"
                  to get the discount.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>Q. How safe is my car in the parking area?</h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  All parking areas at the airport are provided to park at your
                  own risk. All sites are regularly patrolled for airport
                  security purposes.
                </p>
              </div>
            </div>

            <div class="faq-wrapper">
              <div class="faq-toggler" @click="toggleFaq($event)">
                <h2>
                  Q. My flight is delayed. I will return an hour later than
                  scheduled. Do I have to pay extra for parking?
                </h2>
                <i class="fas fa-chevron-right"></i>
              </div>
              <div class="faq-content-wrap">
                <p>
                  No, you will not have to pay extra if the maximum delay is up
                  to 4 hours. The booking system automatically provides you with
                  an additional time of up to 4 hours.
                </p>
              </div>
            </div>
          </template>
        </div>

        <!-- ends left starts right -->

        <!-- <div class="page-right">
          <Basket
            :passedclass="`active`"
            :positionTop="`30px`"
            :position="`relative`"
            :showButton="showButton"
            :lang="`EN`"
            :fmmtransobjpassed="fmmtransobj"
            :key="basketKey"
            :hasItems="hasItems"
            :basketitems="basketitems_final"
            :totalfee="totalfee"
            :bookingfee="bookingfee"
          ></Basket>
        </div> -->
      </div>
    </div>

    <Footernwi
      v-if="brandSlug === 'NWI'"
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="brandSlug"
    ></Footernwi>
    <Footer
      v-else
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="brandSlug"
    ></Footer>

    <Cookies :brandSlug="setbrandid" :translations="translations"/>
    <CookiesOld :brandSlug="setbrandid" v-if="setbrandid === 'RDU'" />
    <!-- <BasetimerModel v-if="covid_test_in_basket" /> -->
  </div>
</template>

<script>
import apiProxy from "../../services/apiProxy";
import Header from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import Footernwi from "../../components/FooterNWI.vue";
import ConfirmationBanner from "../../components/ConfirmationBanner.vue";
import Cookies from "../../components/Cookies.vue";
import CookiesOld from "../../components/Cookies_old.vue";
import { slide } from "../../modules/slideToggle";

import { reactive } from "vue";

import md5 from "js-md5";
import { loadTranslations } from "@/modules/loadTranslations";

import { set_style_vars } from "@/modules/set_style_vars";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Footernwi,
    ConfirmationBanner,
    Cookies,
    CookiesOld,
    // Basket,
    // Basetimer,
    // BasetimerModel
  },
  data() {
    return {
      faqs_api_data: [],
      styles_loaded: false,
      lang: "en",
      translations: "",
      css_data: undefined,
      results_headline: "Official airport parking",
      results_subheadline: "11 Dec 2021 at 9:00 am - 11 Dec 2021 at 9:00 am",
      brand_data: undefined,
      brand_data_key: 0,
      brand_product_styles: reactive({}),
      brand_product_settings: {},
      brand_products: {},
      hero_desktop_background: "",
      hero_mobile_background: "",
      logo_image: "",
      hero_font_size_h1: "1.5rem",
      hero_font_size_h1_mobile: "1.3rem",
      hero_font_size_p: "1.3rem",
      hero_font_size_p_mobile: "1rem",
      hero_text_align: "center",
      hero_text_align_mobile: undefined,
      use_local_data: false,
      header_menu: [],
      footer_links: [],
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      panels_background_color: "#d6d6d6",
      panels_group: undefined,
      panel_columns: 1,
      footer_columns: "1 Columns",
      show_basket: false,
      result_selected_style: "list",
      result_selected_order: "closest",
      setbrandid: "",
      currency: "",
    };
  },
  computed: {
    new_style_variables() {
      return set_style_vars(this.brand_product_styles);
    },
    set_style_variables: function () {
      return {
        "--hero-background-mobile": `url(${this.hero_desktop_background})`,
        "--hero-background-desktop": this.hero_mobile_background
          ? `url(${this.hero_mobile_background})`
          : `url(${this.hero_desktop_background})`,
        "--hero-font-size-h1": this.hero_font_size_h1,
        "--hero-font-size-h1-mobile": this.hero_font_size_h1_mobile,
        "--hero-font-size-p": this.hero_font_size_p,
        "--hero-font-size-p-mobile": this.hero_font_size_p_mobile,
        "--hero-text-align": this.hero_text_align,
        "--hero-text-align-mobile":
          this.hero_text_align_mobile || this.hero_text_align,
        "--panel-background-color": this.panels_background_color,
      };
    },
  },
  methods: {
    toggleFaq(e) {
      let faqtogglers = document.querySelectorAll(".faq-toggler");
      if (faqtogglers) {
        [].forEach.call(faqtogglers, function (el) {
          if (el !== e.target) {
            el.classList.remove("opened");
            slide.up(el.parentElement.querySelector(".faq-content-wrap"), 300);
          }
        });
        if (e.target.getAttribute("class").indexOf("opened") > -1) {
          slide.up(
            e.target.parentElement.querySelector(".faq-content-wrap"),
            300
          );
          e.target.classList.remove("opened");
        } else {
          slide.down(
            e.target.parentElement.querySelector(".faq-content-wrap"),
            300
          );
          e.target.classList.add("opened");
        }
      }
    },

    getrans(string) {
      const s = md5(string);
      const ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      return this.translations[ss] || string;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    async loadTranslations() {
      this.translations = await loadTranslations(this.setbrandid);
      this.lang = sessionStorage.getItem('language') || this.lang || 'en';
    },

    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    setBrandData() {
      this.brand_data = this.getLocalData("brand_data");
      if (!this.brand_data || !this.brand_data.brand_product_styles) {
        console.warn('setBrandData: brand_data not available, skipping');
        return;
      }
      this.setStyles(this.brand_data.brand_product_styles);
      this.brand_product_settings = this.brand_data.brand_product_settings;
      this.brand_products = this.brand_data.brand_products;
      this.brand_data_key++;
      this.styles_loaded = true;
    },
    async getBrandData() {
      if (this.use_local_data && this.getLocalData("brand_data")) {
        this.setBrandData();
      } else {
        const response = await apiProxy.call('brand_details', { brandslug: this.setbrandid });
        if (response && response.code == '1') {
          this.setLocalData("brand_data", response);
          this.setMenu(response);
          this.setBrandData();
        }
      }
    },
    setStyles(obj) {
      if (!obj || !Array.isArray(obj)) {
        console.warn('setStyles: obj not available or not array, skipping');
        return;
      }
      /* eslint-disable */
      obj.forEach((item) => {
        for (const [classname, style] of Object.entries(item)) {
          this.brand_product_styles[classname] = style;
        }
      });
      this.logo_image = this.brand_product_styles["asset_image_1"];
      this.hero_font_size_h1 =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_h1_mobile =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_p = this.brand_product_styles["panel_text_font_size"];
      this.hero_font_size_p_mobile =
        this.brand_product_styles["panel_text_font_size"];
      /* eslint-enable */
    },
    setMenu(data) {
      if (!data || !data.brand_menu || !Array.isArray(data.brand_menu)) {
        console.warn('setMenu: brand_menu not available, skipping');
        return;
      }
      data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (
            menu.label.toLowerCase() !== "home" &&
            menu.label.toLowerCase() !== "logo"
          ) {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    async getbranded() {
      const response = await apiProxy.call('brand_slug');
      if (response && response.code == "1") {
        this.setbrandid = response.slug;
        this.brandSlug = response.slug;
        this.currency = response.currency;
        if (["HER", "NOC", "SZG", "FM1", "PB1", "BRE", "NUE"].includes(response.slug)) {
          this.currency = "€";
        }
        await this.loadTranslations();
        await this.getBrandData();
        this.get_faqs_api_data();
      }
    },

    async get_faqs_api_data() {
      let brand_id = this.setbrandid;
      if (brand_id === "BH2") { brand_id = "BHX"; }
      const response = await apiProxy.call('faq_list', {
        brand_id,
      });
      if (response && response.data) {
        this.faqs_api_data = response.data;
        this.faqs_api_data = this.sort_faq_order(this.faqs_api_data);
      }
    },

    sortBySortOrder(data) {
        return data.sort((a, b) => a.sort_order - b.sort_order);
    },

    sort_faq_order(faq) {
        return this.sortBySortOrder(faq);
    },
    
  },
  created() {},
  mounted() {
    // Remove the loader once Vue is initialized
    const loader = document.getElementById('loader');
    if (loader) {
      loader.parentNode.removeChild(loader);
    }
    //this.setbrandid = "BOS";this.currency="$";
    this.getbranded();
    console.log("window.location.hostname", window.location.hostname);
    //if(this.setbrandid=="")
    // {
    //   this.setbrandid = "BOS";this.currency="$";
    //   if (window.location.hostname == "herv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "HER";this.currency="€";
    //   }
    //   if (window.location.hostname == "nwiv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "NWI";this.currency="£";
    //   }
    //   if (window.location.hostname == "rduv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "RDU";this.currency="$";
    //   }
    //   if (window.location.hostname == "bosv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "BOS";this.currency="$";
    //   }
    // }
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/override_brand.scss";
</style>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

.confirmation-banner-container {
  height: 171px;
  background: var(
    --header_banner_background,
    transparent linear-gradient(#0871b9 0%, #034a94 100%) 0% 0% no-repeat
      padding-box
  );
  display: flex;
  align-items: center;

  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
  }
}

$basketWidth: "420px";
.page-container {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  height: auto;
  position: relative;
  .page-time-notice {
    text-align: left;
    display: flex;
    padding: 10px 0;
    p {
      max-width: calc(100% - 120px);
      padding-right: 30px;
      line-height: 1.4;
      font-size: 18px;
      font-family: $font-family-medium;
    }
    .base-timer-wrapper {
      width: 90px;
      height: 90px;
      margin-top: 15px;
    }
    @media screen and (max-width: 500px) {
      flex-direction: column-reverse;
      text-align: center;
      width: 100%;
      p {
        max-width: 100%;
        padding-right: 0px;
        line-height: 1.4;
        font-size: 18px;
      }
      .base-timer-wrapper {
        margin: 10px auto 0;
      }
    }
  }
  .page-left {
    margin: 0 15px;
    margin-bottom: 40px;
    width: 100%;
    @media screen and (min-width: 958px) {
      // width: calc((100% - #{$basketWidth}) - 45px);
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }
  .page-right {
    width: 0px;
    @media screen and (min-width: 958px) {
      display: block;
      // width: #{$basketWidth};
      min-height: 500px;
      margin-right: 8px;
    }
  }
}

.faq-top-section {
  text-align: left;
  margin: 50px 15px;
  @media screen and (min-width: 958px) {
    margin: 3rem 2rem 1rem;
  }
  p {
    color: $page-text;
    line-height: 1.5;
    font-family: $font-family-medium;
  }
  h2 {
    color: $page-titles;
    font-family: $font-family-bold;
  }
}
.faq-wrapper {
  .faq-toggler {
    color: $faq-expansion-text;
    cursor: pointer;
    user-select: none;
    h2 {
      text-align: left;
      font-size: 18px;
      flex-basis: 100%;
      font-family: $font-family-bold;
    }
    .fa-chevron-right {
      transition: 0.2s ease-in-out;
      display: block;
      width: 15px;
      height: 15px;
    }
    &.opened .fa-chevron-right {
      transform: rotate(90deg);
    }
    & > * {
      pointer-events: none;
      user-select: none;
      padding: 0;
      margin: 0;
    }
    // styles
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px 15px;
    @media screen and (min-width: 958px) {
      padding: 15px 30px;
    }
  }
  .faq-content-wrap {
    display: none;
    padding: 0 0 30px;
    margin: 0px;
    p {
      color: $page-text;
      line-height: 1.5;
      margin: 0px;
      text-align: left;
      padding: 15px 15px 0;
      font-family: $font-family-medium;
      font-size: 16px;
      a {
        color: $page-links;
      }
      @media screen and (min-width: 958px) {
        padding: 15px 30px 0;
      }
    }
  }
  &:nth-child(even) {
    background: #efefef;
  }
  &:nth-child(odd) {
    background: #fff;
  }
}

p {
  color: $page-text;
  line-height: 1.4;
  font-size: 18px;
  a {
    color: $page-links;
    &:hover {
      color: darken($page-links, 10%);
    }
  }
}
</style>
